import React from 'react';
import logo from './logo.svg';
import './App.scss';
import Header from './Header';

function App() {
  return (
    <div className="App">
      <Header></Header>
    </div>
  );
}

export default App;
